export const SN_UTIL = 'util'
export const UTIL_ROLES_UPDATED = SN_UTIL + '/ROLES_UPDATED'
export const UTIL_PRODUCT_STORES_UPDATED = SN_UTIL + '/PRODUCT_STORES_UPDATED'
export const UTIL_SECURITY_GROUPS_UPDATED = SN_UTIL + '/SECURITY_GROUPS_UPDATED'
export const UTIL_FACILITIES_UPDATED = SN_UTIL + '/FACILITIES_UPDATED'
export const UTIL_SHOPIFY_SHOPS_UPDATED = SN_UTIL + '/SHOPIFY_SHOPS_UPDATED'
export const UTIL_CLASSIFICATION_SECURITY_GROUPS_UPDATED = SN_UTIL + '/CLASSIFICATION_SECURITY_GROUPS_UPDATED'
export const UTIL_ORGANIZATION_PARTY_ID_UPDATED = SN_UTIL + '/ORGANIZATION_PARTY_ID_UPDATED'
